import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { deleteResult } from '../../common/results/actions'
import { EmptyList, Button } from '../components'

const ResultsList = ({ results, test, testAsTitle, intl, viewer, deleteResult }) => (
  <div className="results-list">
    {
      results.length ?
        results.map(r => (
          <div className="item-box" key={r.id}>
            <Link to={`/app/result/${r.id}`}>
              {(testAsTitle) ? (r.test ? r.test.name : r.homework.name) : r.student.name}<br />
              {intl.formatMessage(messages.points)}: {`${r.points}/${r.maxPoints} - (${((r.points / r.maxPoints) * 100).toFixed(1)}%)`}
              <span className="small-text spacing">
                &nbsp;{moment(r.createdAt).locale(viewer.userLanguage).format('llll')}
              </span>
              {/* r.openedWindow && <span>Bolo otvorené iné okno!</span> */}
            </Link>
            <div className="float-right">
              <Link to={`/app/result/${r.id}`}>
                <Button>{intl.formatMessage(messages.answers)}</Button>
              </Link>
              {
                r.teacher === viewer.id &&
                <Button
                  negative
                  icon="trash"
                  onClick={() => deleteResult(r.id)}
                >
                  {intl.formatMessage(messages.delete)}
                </Button>
              }
            </div>
          </div>
        ))
      :
        test ?
          <EmptyList
            title={intl.formatMessage(messages.noResults)}
          >
            <p>
              {intl.formatMessage(messages.resultsOfTestWillShow, { testId: test.testId })}
            </p>
          </EmptyList>
        :
          <EmptyList
            title={intl.formatMessage(messages.noResults)}
            text={intl.formatMessage(messages.resultsWillShow)}
          />
    }
  </div>
)

ResultsList.defaultProps = {
  results: [],
  testAsTitle: false,
  test: null,
}

ResultsList.propTypes = {
  deleteResult: PropTypes.func.isRequired,
  viewer: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  results: PropTypes.array,
  test: PropTypes.object,
  testAsTitle: PropTypes.bool,
}


const enhance = compose(
  connect((state) => ({
    viewer: state.users.viewer,
  }), { deleteResult }),
  injectIntl,
)

export default enhance(ResultsList)

const messages = defineMessages({
  points: {
    id: 'results.list.points',
    defaultMessage: 'Body',
  },
  answers: {
    id: 'results.list.answers',
    defaultMessage: 'Odpovede',
  },
  delete: {
    id: 'results.list.delete',
    defaultMessage: 'Vymazať',
  },
  noResults: {
    id: 'results.list.noResults',
    defaultMessage: 'Zatiaľ žiadne výsledky.',
  },
  resultsWillShow: {
    id: 'results.list.resultsWillShow',
    defaultMessage: 'Tu sa zobrazia výsledky žiakov.',
  },
  resultsOfTestWillShow: {
    id: 'results.list.resultsOfTestWillShow',
    defaultMessage: 'Tu sa zobrazia výsledky z testov, ktoré žiaci vyplnia na adrese: vobo.io/test/{testId}',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/ResultsList.js